import { Link } from 'react-router-dom';

/* Compatibility shim: a simple brand CTA band pointing at the contact page. */
export default function DemoCTA() {
  return (
    <div className="rounded border border-hairline bg-surface p-8 text-center">
      <p className="font-serif text-2xl">See it against your own content.</p>
      <p className="mx-auto mt-2 max-w-measure text-sm leading-relaxed text-slate">
        Demos are live and specific: your board, your school, your exam, your route.
      </p>
      <Link to="/contact" className="btn-primary mt-6">
        Request a demo
      </Link>
    </div>
  );
}
